import React, { PropsWithChildren, useContext, useEffect } from "react";
import { useAuthQuery as useQuery } from '../shared/hooks/useAuthQuery';
import { Navigate, useLocation } from "react-router-dom";
import { MainRoutes } from "../shared/models";
import { useConvexAuth } from "convex/react";
import { Spinner } from "../catalyst-components/spinner";
import { usePresence } from "../shared/hooks/usePresence";
import { api } from "../convex/_generated/api";
import { BaseContext } from "../shared/base-context";
import { useStableQuery } from "../shared/hooks/useStableQuery";


export const AuthenticatedRoute: React.FC<PropsWithChildren> = ({children}) => {
    const { isLoading, isAuthenticated } = useConvexAuth();
    const { online, isOnline } = usePresence(MainRoutes.Chat);
    const location = useLocation();
    const {convexUserId} = useContext(BaseContext);

    // Check if user needs to accept legal documents
    const disclaimerStatus = useStableQuery(api.disclaimers.needsDisclaimerAcceptance, convexUserId ? { user_id: convexUserId } : 'skip');
    const privacyPolicyStatus = useStableQuery(api.privacy_policy.needsPrivacyPolicyAcceptance, convexUserId ? { user_id: convexUserId } : 'skip');

    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <Spinner className="w-16 h-16" />
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to={MainRoutes.Landing} replace />;
    }

    // Only check legal docs after confirming the user is authenticated
    if (!disclaimerStatus || !privacyPolicyStatus) {
        return (
            <div className="flex justify-center items-center h-screen">
                <Spinner className="w-16 h-16" />
            </div>
        );
    }

    if (disclaimerStatus.needsAcceptance || privacyPolicyStatus.needsAcceptance) {
        return <Navigate to={MainRoutes.LegalAcceptance} replace />;
    }

    return <>{children}</>;
};
